// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartHeaderStyles } from "@awc/Overrides/Widgets/Cart/CartHeader";
import { css } from "styled-components";

cartHeaderStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
    `,
};
cartHeaderStyles.approverInfoGridItem = {
    css: css`
        margin-top: 16px;
        &:has( > div:empty) {
            display: none;
        }
    `,
};